import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitListingMapCheckbox = (status: boolean) => {
    hitGoogleTagManager({
        event: "map_railroad",
        railroad_status: status
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitListingMapCheckbox = (status: boolean) => {
    hitGoogleTagManager({
        event: "map_railroad",
        railroad_status: status
    });
};
